// RITA-1498 (Nutzungserfassung Phase 1b) — Browser-Pfad → Routen-Muster.
//
// Der Server (apps/backend/src/services/usage/batchSchema.ts, isSafeRoute) nimmt nur Muster wie
// '/agent/:number' an und lehnt Segmente aus Ziffern oder UUIDs ab. Deshalb wird hier jeder Pfad
// gegen die zentrale Routenliste (routes/paths.ts) abgeglichen; Query-String und Anker werden
// verworfen. Alles Unbekannte (404, Weiterleitungen, '/') wird zur Sonderroute 'unbekannt'.
import { matchPath } from 'react-router-dom';
import { PagePathname } from '../../../routes/paths';

export const UNKNOWN_ROUTE = 'unbekannt';
export const MAX_ROUTE_LENGTH = 128;

const ALL_PATTERNS: readonly string[] = Object.values(PagePathname);

const stripPath = (raw: string): string => {
  const [withoutHash] = raw.split('#');
  const [withoutQuery] = withoutHash.split('?');
  if (withoutQuery.length > 1 && withoutQuery.endsWith('/')) {
    return withoutQuery.slice(0, -1);
  }
  return withoutQuery;
};

const isParametric = (pattern: string): boolean => pattern.includes(':');

/**
 * Liefert das Routen-Muster zum Pfad. Exakte Muster gewinnen vor parametrischen
 * ('/einstellung/systemdienstleister/neu' vor '/einstellung/systemdienstleister/:id').
 */
export const toRoutePattern = (pathname: string, patterns: readonly string[] = ALL_PATTERNS): string => {
  const path = stripPath(pathname || '');
  if (!path.startsWith('/')) return UNKNOWN_ROUTE;

  if (patterns.some((pattern) => !isParametric(pattern) && pattern === path)) {
    return path;
  }
  const match = patterns.find(
    (pattern) => isParametric(pattern) && matchPath({ path: pattern, end: true }, path) !== null,
  );
  if (!match || match.length > MAX_ROUTE_LENGTH) return UNKNOWN_ROUTE;
  return match;
};
